module.exports = __webpack_public_path__ + "img/target_check.db73d94f.svg";